import React, { FC } from 'react'
import { IHistoryAnnualTotal } from '../../../../interfaces/IHistory'
import { roundTwoDecimals } from '../../../../utils/helpers'
import DynamicFormattedMessage from '../../../common/ui/DynamicFormattedMessage'

export const AnnualTableRow: FC<IHistoryAnnualTotal> = ({
  currentYear,
  previousYear,
  name,
  customClass = '',
  rafQty,
}) => {
  return (
    <tr className={`textPrimary textCustomXs ${customClass}`}>
      <td>
        {name || (
          <DynamicFormattedMessage
            id="page.history.annual.total"
            className="textUppercase"
          />
        )}
      </td>
      <td className="textCenter">{currentYear?.TOTAL2?.quantity || '-'}</td>
      <td className="textCenter">
        {roundTwoDecimals(currentYear?.TOTAL2?.value) || '-'}
      </td>
      <td className="textCenter">{previousYear?.TOTAL1?.quantity || '-'}</td>
      <td className="textCenter">
        {roundTwoDecimals(previousYear?.TOTAL1?.value) || '-'}
      </td>
      <td className="textCenter">{rafQty ? roundTwoDecimals(rafQty) : 0}</td>
    </tr>
  )
}
